/**
 * @flow
 * @relayHash 0ad98e0d772e07a415c732da9993218d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type WidgetsSettingsContainer_app$ref = any;
type WidgetsSettingsContainer_user$ref = any;
export type WidgetsSettingsViewQueryVariables = {|
  userId: string
|};
export type WidgetsSettingsViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: WidgetsSettingsContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: WidgetsSettingsContainer_user$ref
  |},
|};
export type WidgetsSettingsViewQuery = {|
  variables: WidgetsSettingsViewQueryVariables,
  response: WidgetsSettingsViewQueryResponse,
|};
*/


/*
query WidgetsSettingsViewQuery(
  $userId: String!
) {
  app {
    ...WidgetsSettingsContainer_app
    id
  }
  user(userId: $userId) {
    ...WidgetsSettingsContainer_user
    id
  }
}

fragment WidgetsSettingsContainer_app on App {
  widgets(first: 20) {
    edges {
      node {
        id
        name
        ...WidgetSettingsContainer_appWidget
      }
    }
  }
}

fragment WidgetsSettingsContainer_user on User {
  ...WidgetSettingsContainer_user
  widgets(first: 20) {
    edges {
      node {
        id
        name
        ...WidgetSettingsContainer_widget
      }
    }
  }
}

fragment WidgetSettingsContainer_user on User {
  id
}

fragment WidgetSettingsContainer_widget on Widget {
  id
  name
  enabled
  config
  settings
}

fragment WidgetSettingsContainer_appWidget on Widget {
  id
  name
  type
  settings
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20,
    "type": "Int"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "settings",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "WidgetsSettingsViewQuery",
  "id": null,
  "text": "query WidgetsSettingsViewQuery(\n  $userId: String!\n) {\n  app {\n    ...WidgetsSettingsContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...WidgetsSettingsContainer_user\n    id\n  }\n}\n\nfragment WidgetsSettingsContainer_app on App {\n  widgets(first: 20) {\n    edges {\n      node {\n        id\n        name\n        ...WidgetSettingsContainer_appWidget\n      }\n    }\n  }\n}\n\nfragment WidgetsSettingsContainer_user on User {\n  ...WidgetSettingsContainer_user\n  widgets(first: 20) {\n    edges {\n      node {\n        id\n        name\n        ...WidgetSettingsContainer_widget\n      }\n    }\n  }\n}\n\nfragment WidgetSettingsContainer_user on User {\n  id\n}\n\nfragment WidgetSettingsContainer_widget on Widget {\n  id\n  name\n  enabled\n  config\n  settings\n}\n\nfragment WidgetSettingsContainer_appWidget on Widget {\n  id\n  name\n  type\n  settings\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "WidgetsSettingsViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "WidgetsSettingsContainer_app",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "WidgetsSettingsContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "WidgetsSettingsViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widgets",
            "storageKey": "widgets(first:20)",
            "args": v2,
            "concreteType": "WidgetConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "WidgetEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Widget",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "type",
                        "args": null,
                        "storageKey": null
                      },
                      v5
                    ]
                  }
                ]
              }
            ]
          },
          v3
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v3,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widgets",
            "storageKey": "widgets(first:20)",
            "args": v2,
            "concreteType": "WidgetConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "WidgetEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Widget",
                    "plural": false,
                    "selections": [
                      v3,
                      v4,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "enabled",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "config",
                        "args": null,
                        "storageKey": null
                      },
                      v5
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '31bf55c7dfa924f7f38a30623ff3b467';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Widgets/__generated__/WidgetsSettingsViewQuery.graphql.js